export const CONFIG = {
  OKTA_ISSUER: import.meta.env.VITE_OKTA_ISSUER as string,
  OKTA_CLIENT_ID: import.meta.env.VITE_OKTA_CLIENT_ID as string,
  STORYBLOK_CONTENT_STAGE: import.meta.env
    .VITE_STORYBLOK_CONTENT_STAGE as string,
  API_HOST: import.meta.env.VITE_API_HOST as string,
  NOTIFICATION_REFRESH_INTERVAL:
    Number(import.meta.env.VITE_NOTIFICATION_REFRESH_INTERVAL) || 1000 * 30, // default 30 seconds
  AI_ROUTER_API: import.meta.env.VITE_AI_ROUTER_API as string,
  PEOPLE_FINDER_API_HOST: import.meta.env.VITE_PEOPLE_FINDER_API_HOST as string,
  APP_STAGE: import.meta.env.VITE_APP_STAGE as string,
};
